import { useEffect, useState } from "react";

import $ from "jquery";
import { toast } from "react-hot-toast";

import { callImageUploader, callVideoUploader, getVideoSrcViaRefId } from "utils/UserUtils";

const VideoSelector = ({
  style,
  user = false,
  selectedVideo,
  handleVideoChange,
}) => {
  const [showPreLoader, setShowPreLoader] = useState(true);
  const [showLoader, setShowLoader] = useState(false);
  const [videoRefId, setVideoRefId] = useState(null);
  const [videoUrl, setVideoUrl] = useState("/assets/images/play-video.png");

  useEffect(() => {
    if (videoRefId) {
      handleVideoChange(videoRefId);
      setShowLoader(false);
    }
  }, [videoRefId]);

  const handleImageClick = (e) => {
    $(e.target.parentElement).find("input[type='file']").trigger("click");
  };

  const handleOnChange = (e) => {
    var videoTag = $(e.target.parentElement).find("video");
    const file = e.target.files[0];
    const videoTypes = ["video/mp4", "video/x-m4v", "video/*"];
    const fileType = file.type;
    if (!e.target.files[0] || e.target.files[0] === undefined) {
      return;
    }

    if (!videoTypes.includes(fileType)) {
      toast.error("invalid file type");
      e.target.value = null;
      return;
    }

    // var size = e.target.files[0].size / 1000; // Size in KB
    // if (size > 2048) {
    //   toast.error("image size cannot exceed 2048 KBs");
    //   e.target.value = null;
    // }
    previewVideo(e.target, videoTag);
  };

  const previewVideo = (inputTag, videoTag) => {
    if (inputTag.files && inputTag.files[0]) {
      var reader = new FileReader();
      reader.onload = async function (e) {
        let base64 = e.target.result;
        let fileName = $(inputTag).val().split("\\").pop();
        videoTag.attr("src", base64);
        var base64Video = $(inputTag).parent().find(".base64Video");
        if (base64Video !== undefined) {
          $(base64Video).val(base64);
        }
        try {
          setShowLoader(true);
          let videoRefId = await callVideoUploader(inputTag.files[0]);
          setVideoRefId(videoRefId);
          setShowLoader(false);
        } catch (error) {
          console.log(error)
          setShowLoader(false);
          return;
        }
        handleVideoChange(fileName, base64);
      };
      reader.readAsDataURL(inputTag.files[0]);
    }
  };
  useEffect(() => {
    getselectedVideo();
}, [selectedVideo, videoRefId]);

  const getselectedVideo = () => {
    if (
      selectedVideo === null ||
      selectedVideo === undefined ||
      selectedVideo === ""
    ) {
      setVideoUrl(null);
    } else {
      const videoSrc =  getVideoSrcViaRefId(selectedVideo);
      setVideoUrl(videoSrc)
    }
  };

  const checkVideoLoader = () => {
    if (showPreLoader) {
      setShowPreLoader(false);
    }
  };

  return (
    <div>
      <button className="btn btn-primary" onClick={handleImageClick}>
        Video Upload
      </button>
      <input
        type="file"
        onChange={handleOnChange}
        className="form-control input-default avatarImage d-none"
      />
      <div className="restaurant-images p-2 card border mb-0 text-center mt-2" style={{height:"240px"}}>
        <div className="h-100 d-flex align-items-center  justify-content-center video-bg-img ">
          <div className="w-100">
        <video
          className={videoUrl ? "" : "visually-hidden"}
          width="100%"
          height="215"
          controls
          onLoadStart={checkVideoLoader}
          key={videoUrl}
        >
          <source src={videoUrl} type="video/mp4" />
          <source src={videoUrl} type="video/ogg" />
        </video>
        <input type="hidden" className="avatarImageUrl" value="" />

        <div
          className={
            "imageLoaderParent " +
            (showLoader === true || showPreLoader === true
              ? "d-flex"
              : "d-none")
          }
        >
          <div className="imageLoader">
            <div className="spinner-chase">
              <div className="chase-dot"></div>
              <div className="chase-dot"></div>
              <div className="chase-dot"></div>
              <div className="chase-dot"></div>
              <div className="chase-dot"></div>
              <div className="chase-dot"></div>
            </div>
          </div>
        </div>
        </div>
      </div>
    </div>
    </div>
  );
};

export default VideoSelector;
